import React from "react";
import "./CustomButton.css";

const CustomButton = (props) => {
  const {
    text,
    onClick,
    className,
    height = "48px",
    width = "327px",
    disabled = false,
    isGrayButton = false,
    isWhiteButton = false,
    showErrorMessage = false,
    errorContainer = {},
    errorMessage = "",
    whiteError = false,
  } = props;
  return (
    <div style={{ width: width }}>
      <button
        className={`cb_container display_h4 ${className} ${
          isWhiteButton ? "cb_container_white" : ""
        } ${isGrayButton ? "cb_container_gray" : ""}`}
        onClick={onClick}
        disabled={disabled}
        style={{
          height,
          width,
        }}
      >
        {text}
      </button>
      {showErrorMessage ? (
        <p
          className={`cb_error_message ${errorContainer} ${
            whiteError ? "text-white-color" : ""
          }`}
        >
          {errorMessage || "Please Fix Incorrect or Missing Details to Proceed"}
        </p>
      ) : null}
    </div>
  );
};

export default CustomButton;
